<template>	
	<div style="margin: 0; padding: 0; height: 100%;">		
    <v-data-table
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="apiLoading"
      :loading-text="$t('wkt.admin.common.table.loading')"
      :no-data-text="$t('wkt.admin.common.table.no_data')"
      :no-results-text="$t('wkt.admin.common.table.no_results')"
      :footer-props="{
        'items-per-page-options': [20, 50, 100],
        'items-per-page-text': $t('wkt.admin.common.table.items_per_page'),
        'items-per-page-all-text': $t('wkt.admin.common.table.items_per_page_all')
      }"
      fixed-header
      :class="(showTabs ? 'project-calendar' : 'project-calendar-noTabs') + ' elevation-0'"
      style="background-color: transparent !important;"
      hide-default-header>
        <template v-slot:header>
          <CalendarHeader ref="header" v-if="!apiLoading && items.length > 0" />
      </template>
      <template v-slot:no-data>
        <EmptyState 
        class="pt-10"
          :title="$t('wkt.admin.common.empty-state.title')" 
          :description="$t('wkt.admin.common.empty-state.description')" />
      </template>
      <template v-slot:item="{ item }">
        <CalendarRow 
          v-if="!apiLoading" 
          :data="item" 
          :type="type" 
          :showSummary="showSummary" 
          :onlyVacationData="onlyVacationData" 
          :calendars="calendars" 
          :projects="projects" 
					@show-menu="onShowMenu($event)"
					@show-tooltip="onShowTooltip($event)"
					@hide-tooltip="onHideTooltip()"
          @day-selected="$emit('day-selected', $event)" />
      </template>
      <template v-slot:[`footer.page-text`]="props">        
          {{ props.pageStart }} - {{ props.pageStop }} {{ $t('wkt.admin.paged-tables.pager.of') }} {{ props.itemsLength > props.pageStop ? `+${props.pageStop}` : props.pageStop }}
      </template>
      <template v-slot:[`footer.prepend`]>
        <RefreshWidget 
          ref="refresh" 
          style="position: fixed; left: 625px;"
          @refresh="updateData()" />
      </template>
    </v-data-table>
		
		<v-tooltip 
			v-model="showTooltip" 
			:position-x="tooltipX"
			:position-y="tooltipY"
			color="#000000" 
			bottom 
			absolute>			
				{{ tooltipText }}
		</v-tooltip>

		<v-menu 
			v-model="showMenu" 
			:position-x="menuX"
			:position-y="menuY"
			absolute>
			<v-list class="pa-0 project-calendar">
				<v-list-item @click="$emit('day-selected', { employee: selectedDay.employee, calendar: selectedDay.calendar, vacation: null })">
					<v-list-item-icon style="margin: 12px 20px 10px 0;">
						<v-icon>update</v-icon>
					</v-list-item-icon>
					<v-list-item-title>{{ $t('wkt.admin.projects.calendar.edit-day.dropdown.edit-workday') }}</v-list-item-title>
				</v-list-item>
				<v-list-item @click="$emit('day-selected', { employee: selectedDay.employee, calendar: selectedDay.calendar, vacation: selectedDay.vacation })">
					<v-list-item-icon style="margin: 12px 20px 10px 0;">
						<v-icon>group</v-icon>
					</v-list-item-icon>
					<v-list-item-title>{{ $t('wkt.admin.projects.calendar.edit-day.dropdown.show-vacations') }}</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</div>
</template>

<script>
import BaseModule from '../BaseModule';
import api from '../../../api/worktime';
import EmptyState from '../EmptyState';
import CalendarHeader from './CalendarHeader';
import CalendarRow from './CalendarRow';
import RefreshWidget from '../RefreshWidget';

export default {
	name: 'CalendarWidget',
	mixins: [BaseModule],
	props: ['view', 'type', 'onlyVacationData', 'showSummary', 'showTabs', 'includeRequests'],
	components: {
		EmptyState, CalendarHeader, CalendarRow, RefreshWidget
	},
	data () {
		return {
      filter: {
        fromDate: null,
        toDate: null,
        employee: null,
      },
      apiLoading: false,
      numDays: 0,
      items: [],
      totalItems: 0,
			options: { itemsPerPage: 20 },
      calendars: [],
      projects: [],
			menuX: 0,
			menuY: 0,
			showMenu: false,
			tooltipX: 0,
			tooltipY: 0,
			showTooltip: false,
			tooltipText: '',
			selectedDay: null,
		}
	},
	methods: {
    init(currentYear, currentMonth, currentWeek, calendars, projects) {
			this.year = currentYear;
      if (this.view === 0) {
        const month = currentMonth;
        this.filter.fromDate = this.getFirstDayOfMonth(month, this.year);
        this.filter.toDate = this.getLastDayOfMonth(month, this.year);
        this.numDays = this.getNumOfDaysInMonth(month, this.year);
      } else if (this.view === 1) {
        const week = currentWeek;
        this.filter.fromDate = this.getFirstDayOfWeek(week, this.year);
        this.filter.toDate = this.getLastDayOfWeek(week, this.year);
        this.numDays = 7;
      }
      this.calendars = calendars ? calendars : [];
      this.projects = projects ? projects : [];
    },
    updateFilter(filter) {
      this.filter = filter;
      this.options.page = 1;
      this.updateData();
    },
    updateData() {
      if (!this.filter.fromDate || !this.filter.toDate) {
        return;
      }

			this.items = [];
			this.apiLoading = true;
        
      //Obtenemos los filtros del local storage
      const panelFilters = this.readFiltersFromLocalStorage(this.renderMode);
  
      const { page, itemsPerPage } = this.options;

      const request = {
        offset: (page ? page - 1 : 0) * itemsPerPage,
        count: itemsPerPage,
        fromDate: this.convertDateToSimpleDate(this.filter.fromDate),
        toDate: this.convertDateToSimpleDate(this.filter.toDate),
        onlyVacationEmployees: this.onlyVacationData,
        includeRequests: this.includeRequests === true,
        filterCalendarIds: panelFilters.filterCalendarIds,
        filterProjectIds: panelFilters.filterProjectIds,
        textFilter: this.filter.employee
			};

      const me = this;

			api.getEmployeeCalendarPaginated(request,
				data => {
					me.apiLoading = false;

					me.items = data.entities;
					me.totalItems = data.total;

          this.$nextTick(function() {
            if (me.$refs.header) {
              me.$refs.header.createHeader(this.filter.fromDate, this.filter.toDate, this.view, this.showSummary);
            }
            me.$refs.refresh.update();
          });
				}, 
        err => {
						me.apiLoading = false;
						console.log(err);
						me.$emit('alert-event', { text: err.message, color: 'error', timeout: 3000 });
				});
		},            
    readFiltersFromLocalStorage(renderMode) {
      if (renderMode === 2) {
          return { filterCalendarIds: null, filterProjectIds: null };
      }

      let filterCalendarIds = null;
      let filterProjectIds = null;

      const filterCalendars = localStorage.getItem('project-calendar-filter-employee-calendar');
      if (filterCalendars && filterCalendars === 'true') {
        const filterCalendar = localStorage.getItem('project-calendar-filter-calendar');
        if (!filterCalendar) {
          return { filterCalendarIds: null, filterProjectIds: null };
        }

        //console.log(`filterCalendar: ${filterCalendar}`);
        let filterCalendarItems = filterCalendar.split(';');
        //console.log(`filterCalendarItems: ${filterCalendarItems}`);
        filterCalendarItems = filterCalendarItems.filter(i => i.split(',')[1] === 'true');
        //console.log(`filterCalendarItems: ${filterCalendarItems}`);
        filterCalendarIds = filterCalendarItems.map(i => parseInt(i.split(',')[0]));
        //console.log(`filterCalendarIds: ${filterCalendarIds}`);
      }

      const filterProjects = localStorage.getItem('project-calendar-filter-employee-project');
      if (filterProjects && filterProjects === 'true') {
        const filterProject = localStorage.getItem('project-calendar-filter-project');
        if (!filterProject) {
            return { filterCalendarIds: filterCalendarIds, filterProjectIds: null };
        }
        
        //console.log(`filterProject: ${filterProject}`);
        let filterProjectItems = filterProject.split(';');
        //console.log(`filterProjectItems: ${filterProjectItems}`);
        filterProjectItems = filterProjectItems.filter(i => i.split(',')[1] === 'true');
        //console.log(`filterProjectItems: ${filterProjectItems}`);
        filterProjectIds = filterProjectItems.map(i => parseInt(i.split(',')[0]));
        //console.log(`filterProjectIds: ${filterProjectIds}`);
      }

      return { filterCalendarIds: filterCalendarIds, filterProjectIds: filterProjectIds };
    },
		onShowMenu(data) {
			this.onHideTooltip();

			this.selectedDay = data.day;
			this.menuX = data.x;
			this.menuY = data.y;
			this.showMenu	= true;		
		},
		onShowTooltip(data) {
			this.tooltipText = data.text;
			this.tooltipX = data.x;
			this.tooltipY = data.y;
			this.showTooltip = true;
		},
		onHideTooltip() {
			this.showTooltip = false;
		},
	},
	watch: {
    options: {
			handler () {
				this.$log.debug(this.options);
				this.updateData();
			},
			deep: true,
		},
	},
}
</script>
